import SHelp from './SHelp.vue';
import Vue from 'vue';
import { DirectiveOptions } from 'vue/types/options';
import i18n from '@/i18n';

interface IHelpComponent extends SHelp {
  id?: number;
  name: string;
  content: string;
}

const HelpConstructor = Vue.extend(SHelp);

const Help: IHelp = ({ name, content, element }) => {
  const id = Help.id++;
  const options = { name, content, element, id };
  const instance = (new HelpConstructor({
    propsData: options,
    i18n,
  }) as IHelpComponent);
  instance.$mount();
  instance.$el.getElementsByClassName('help-wrapper')[0].classList.add('help-directive');
  if (element) {
    element.appendChild(instance.$el);
    element.classList.toggle('has-help-info');
    element.style.position = 'relative';
  }
  Help.instances.push(instance);
  return instance;
};

// eslint-disable-next-line no-array-constructor
Help.instances = [];
Help.id = 0;
Help.instance = id => Help.instances.find(help => help.id === Number(id));

export default Help;

export interface IHelp {
  ({ name, content, element }:
    { name: string; content: string; element: HTMLElement }):
    IHelpComponent;
  instances: IHelpComponent[];
  id: number;
  instance: (id: string | undefined) => IHelpComponent | undefined;
}

export const HelpDirective: DirectiveOptions = {
  bind: (el, binding) => {
    const data = {
      element: el,
      name: binding.value,
      content: binding.arg ? binding.arg : '',
    };
    const instance = Help(data);
    el.dataset.id = String(instance.id);
  },
  update: (el, binding) => {
    const instance = Help.instance(el.dataset.id);
    if (instance) {
      instance.name = binding.value;
      instance.content = binding.arg ? binding.arg : '';
    }
  },
  unbind: el => {
    const instance = Help.instance(el.dataset.id);
    if (instance) instance.$destroy();
  },
};
